export const DEVICE_LIST_SUCCESS = "DEVICE_LIST_SUCCESS";
export const DEVICE_LIST_FAIL = "DEVICE_LIST_FAIL";
export const DEVICE_ADD_SUCCESS = "DEVICE_ADD_SUCCESS";
export const DEVICE_ADD_FAIL = "DEVICE_ADD_FAIL";
export const DEVICE_DELETE_SUCCESS = "DEVICE_DELETE_SUCCESS";
export const DEVICE_DELETE_FAIL = "DEVICE_DELETE_FAIL";
export const DEVICE_INFO_SUCCESS = "DEVICE_INFO_SUCCESS";
export const DEVICE_INFO_FAIL = "DEVICE_INFO_FAIL";
export const DEVICE_STOLEN_STATUS_SUCCESS = "DEVICE_STOLEN_STATUS_SUCCESS";
export const DEVICE_STOLEN_STATUS_FAIL = "DEVICE_STOLEN_STATUS_FAIL";
export const DEVICE_LOCK_STATUS_SUCCESS = "DEVICE_LOCK_STATUS_SUCCESS";
export const DEVICE_LOCK_STATUS_FAIL = "DEVICE_LOCK_STATUS_FAIL";
export const RESET_DEVICE_DETAILS = "RESET_DEVICE_DETAILS";
export const STORE_DEVICE_DETAILS = "STORE_DEVICE_DETAILS";
export const DEVICE_TYPE_LIST_SUCCESS = "DEVICE_TYPE_LIST_SUCCESS";
export const DEVICE_TYPE_LIST_FAIL = "DEVICE_TYPE_LIST_FAIL";

export const defaultDeviceState = {
  devices: null,
  device: null,
  deviceTypes: null
};
export default (state = defaultDeviceState, action) => {
  switch (action.type) {
    case DEVICE_LIST_SUCCESS:
      return {
        ...state,
        devices: action.payload.data
      };
    case DEVICE_LIST_FAIL:
      return {
        ...state
      };
    case DEVICE_ADD_SUCCESS:
      return {
        ...state
      };
    case DEVICE_ADD_FAIL:
      return {
        ...state
      };
    case DEVICE_DELETE_SUCCESS:
      return {
        ...state
      };
    case DEVICE_DELETE_FAIL:
      return {
        ...state
      };
    case DEVICE_INFO_SUCCESS:
      return {
        ...state,
        device: action.payload.data
      };
    case DEVICE_INFO_FAIL: {
      return {
        ...state
      };
    }
    case DEVICE_STOLEN_STATUS_SUCCESS:
    case DEVICE_STOLEN_STATUS_FAIL:
    case DEVICE_LOCK_STATUS_SUCCESS:
    case DEVICE_LOCK_STATUS_FAIL: {
      return {
        ...state
      };
    }
    case STORE_DEVICE_DETAILS: {
      return {
        ...state,
        device: action.payload
      };
    }
    case RESET_DEVICE_DETAILS: {
      return {
        ...state,
        device: {}
      };
    }
    case DEVICE_TYPE_LIST_SUCCESS:
      return {
        ...state,
        deviceTypes: action.payload.data
      };
    case DEVICE_TYPE_LIST_FAIL: {
      return {
        ...state
      };
    }
    default:
      return {
        ...state
      };
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/deviceReducer.js